import { render, staticRenderFns } from "./cadastro.vue?vue&type=template&id=69308e8b&scoped=true&"
import script from "./cadastro.vue?vue&type=script&lang=js&"
export * from "./cadastro.vue?vue&type=script&lang=js&"
import style0 from "./cadastro.vue?vue&type=style&index=0&id=69308e8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69308e8b",
  null
  
)

export default component.exports